export const returnFlexibleFlag = (
	arriving: Date | string | null,
	initialDateFlexible: boolean,
	departing: Date | string | null,
	finalDateFlexible: boolean,
) => {
	let arrivalDate
	let departingDate
	if (arriving && initialDateFlexible) {
		arrivalDate = arriving + ' Flexible'
	} else if (!arriving && initialDateFlexible) {
		arrivalDate = 'Flexible'
	} else {
		arrivalDate = arriving
	}

	if (departing && finalDateFlexible) {
		departingDate = departing + ' Flexible'
	} else if (!departing && finalDateFlexible) {
		departingDate = 'Flexible'
	} else {
		departingDate = departing
	}

	return {
		departingDate,
		arrivalDate,
	}
}
